/**
 * Local Database - Shared Report Helpers
 *
 * Shared utilities used by the report generation functions.
 */

import type { LocalAccount } from './types'

/**
 * Find the ancestor of an account at the given target depth.
 * If the account itself is at or shallower than targetDepth, returns the account.
 * Walks up the parent chain until reaching targetDepth.
 * Returns null if the account is a header.
 */
export function findAncestorAtDepth(
  account: LocalAccount,
  targetDepth: number,
  allAccounts: LocalAccount[]
): LocalAccount | null {
  /* v8 ignore next */
  if (account.isHeader) { return null }
  if (account.depth <= targetDepth) { return account }

  let current: LocalAccount = account
  let parent: LocalAccount | undefined = allAccounts.find(a => a.id === current.parentId)

  while (parent && !parent.isHeader && current.depth > targetDepth) {
    current = parent
    parent = allAccounts.find(a => a.id === current.parentId)
  }

  /* v8 ignore next */
  return current.depth <= targetDepth ? current : null
}

/**
 * Return today's date as a YYYY-MM-DD string in local timezone.
 */
export function todayString(): string {
  const n = new Date()
  return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, '0')}-${String(n.getDate()).padStart(2, '0')}`
}
